import { render, staticRenderFns } from "./liveBroadcastLanding.vue?vue&type=template&id=cf85b438&scoped=true"
import script from "./liveBroadcastLanding.vue?vue&type=script&lang=js"
export * from "./liveBroadcastLanding.vue?vue&type=script&lang=js"
import style0 from "./liveBroadcastLanding.vue?vue&type=style&index=0&id=cf85b438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf85b438",
  null
  
)

export default component.exports